export const sizeByKeyname = {
    large: 40,
    normal: 36,
    small: 28,
};
export const sizeByLetter = {
    l: 40,
    m: 36,
    s: 28,
};
//# sourceMappingURL=constants.js.map